const $nav = $('.js-nav-top');
const $hamburger = $('.js-toggle-nav');
const $header = $('.header');
const Nav = {};


$hamburger.on('click', function(event) {
	event.preventDefault();
	if ($nav.hasClass('is-open')) {
		$nav.velocity("fadeOut", {
			duration: 250,
			begin: function () {
				// if ($('html').hasClass('bx-touch')) {
				// 	$('html').css('overflow', '');
				// }
				$hamburger.removeClass('is-active');
				$nav.removeClass('is-open');
				$header.removeClass('nav-opened');
				// $('.js-toggle-view-nav')
				// 	.velocity("fadeIn", {
				// 		duration: 50
				// 	});
			},
			complete: function () {
			}
		});
	} else {
		$nav.velocity("fadeIn", {
			duration: 250,
			begin: function () {
				if ($('html').hasClass('bx-touch')) {
					// $('html')
					// 	.velocity('stop')
					// 	.velocity('scroll', { duration: 10 })
					// 	.css('overflow', 'hidden');
				}
				$hamburger.addClass('is-active');
				$header.addClass('nav-opened');
				// $('.js-toggle-view-nav')
				// 	.velocity("fadeOut", {
				// 		duration: 50
				// 	});
			},
			complete: function () {
				$nav.addClass('is-open');
			}
		});
	}

});

Nav.initNavDesktop = function() {
	$nav
		.on('click', '.js-top-link:not(.js-top-link--single):not(.is-opened)', function(e) {
			e.preventDefault();
			Nav.showChildsDesktop($(this));
		});

	$(document).on('click', function (e) {
		if ($('.nav__slide.is-opened').length) {
			if (!$('.nav__slide').is(e.target) && $('.nav__slide').has(e.target).length === 0) {
				Nav.hideChildsDesktop();
			}
		}
	});
}

Nav.showChildsDesktop = function($listItem) {
	var $child = $listItem.closest('li').find('.nav__slide');

	if ($child.hasClass('is-opened')) {
		Nav.hideChildsDesktop();
	} else {
		Nav.hideChildsDesktop();
		$child
			.velocity('stop')
			.velocity('transition.fadeIn', {
				delay: 50,
				duration: 350,
				begin: function () {
					$child.addClass('is-opened');
				}
			});
	}
	$listItem
		.toggleClass('is-opened');
};

Nav.hideChildsDesktop = function() {
	var $childs = $nav.find('.nav__slide.is-opened');

	$('.js-top-link')
		.removeClass('is-opened');
	$childs
		.removeClass('is-opened')
		.velocity('stop')
		.css({
			display: 'none',
			opacity: '0'
		});
};

Nav.initNavDesktop();



// WEBPACK FOOTER //
// ./frontend/components/navigation/navigation.js